import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  id: "themeMask"
};
const _hoisted_2 = ["cx", "cy", "r"];
const _hoisted_3 = ["r"];
const _hoisted_4 = ["opacity"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", {
    id: "themeToggle",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleToggleClick && $options.handleToggleClick(...args))
  }, [_createVNode(_Transition, {
    name: "icon-fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [!$data.isAuto ? (_openBlock(), _createElementBlock("svg", {
      key: "sun-moon",
      class: _normalizeClass(["theme_toggle_svg", {
        'dark': $data.isDark
      }]),
      width: "1.5em",
      height: "1.5em",
      viewBox: "0 0 24 24",
      fill: "none",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      stroke: "currentColor"
    }, [_createElementVNode("mask", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      fill: "white"
    }, null, -1)), _createElementVNode("circle", {
      class: "theme_toggle_circle1",
      fill: "black",
      cx: $data.isDark ? '50%' : '100%',
      cy: $data.isDark ? '23%' : '0%',
      r: $data.isDark ? '9' : '5'
    }, null, 8, _hoisted_2)]), _createElementVNode("circle", {
      class: "theme_toggle_circle2",
      cx: "12",
      cy: "12",
      r: $data.isDark ? '9' : '5',
      mask: "url(#themeMask)"
    }, null, 8, _hoisted_3), _createElementVNode("g", {
      class: "theme_toggle_g",
      stroke: "currentColor",
      opacity: $data.isDark ? 0 : 1
    }, [...(_cache[2] || (_cache[2] = [_createElementVNode("line", {
      x1: "12",
      y1: "1",
      x2: "12",
      y2: "3"
    }, null, -1), _createElementVNode("line", {
      x1: "12",
      y1: "21",
      x2: "12",
      y2: "23"
    }, null, -1), _createElementVNode("line", {
      x1: "4.22",
      y1: "4.22",
      x2: "5.64",
      y2: "5.64"
    }, null, -1), _createElementVNode("line", {
      x1: "18.36",
      y1: "18.36",
      x2: "19.78",
      y2: "19.78"
    }, null, -1), _createElementVNode("line", {
      x1: "1",
      y1: "12",
      x2: "3",
      y2: "12"
    }, null, -1), _createElementVNode("line", {
      x1: "21",
      y1: "12",
      x2: "23",
      y2: "12"
    }, null, -1), _createElementVNode("line", {
      x1: "4.22",
      y1: "19.78",
      x2: "5.64",
      y2: "18.36"
    }, null, -1), _createElementVNode("line", {
      x1: "18.36",
      y1: "5.64",
      x2: "19.78",
      y2: "4.22"
    }, null, -1)]))], 8, _hoisted_4)], 2)) : (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: "auto-mode",
      icon: "circle-half-stroke",
      class: "auto-icon",
      style: {
        "font-size": "1.5em",
        "color": "var(--theme-toggle-color)"
      }
    }))]),
    _: 1
  })]);
}